import { render, staticRenderFns } from "./gc-dashboard-price-groups-card.vue?vue&type=template&id=0050da28"
import script from "./gc-dashboard-price-groups-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-price-groups-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports